import React from 'react';
import {Box, Grid} from '@mui/material';

const TwoColumnsContainer = ({
  leftColumn,
  rightColumn,
  ignoreResponsive,
  rightColumnSx,
}) => (
  <Grid
    container
    sx={{
      height: '100%',
    }}
    // py={2}
  >
    <Grid
      item
      xs={12}
      md={6}
      justifyContent={{
        xs: 'center',
      }}
      display={{
        xs: 'flex',
        md: 'block',
      }}>
      {leftColumn || 'None'}
    </Grid>

    <Box
      item
      component={Grid}
      xs={0}
      md={6}
      sx={{
        // backgroundColor: 'secondary.light',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 422,
        ...rightColumnSx,
        // backgroundColor: 'pink',
      }}
      p={ignoreResponsive ? 2 : 0}
      display={{
        xs: ignoreResponsive ? 'unset' : 'none',
        md: 'flex',
      }}>
      {rightColumn || 'None'}
    </Box>
  </Grid>
);

export default TwoColumnsContainer;
